import { createSlice } from '@reduxjs/toolkit';
import { SharingPermissions } from 'scribe-web-shared/types/document';
import { setScribeDocument } from 'v2/slices/documents/slice';

import { signOut } from '../../../slices/authSlice';
import { setCurrentKnowledgePage, updateKnowledgePage } from '../../../slices/knowledgePageSlice';
import { getScribeFile, setScribeFileData, updateFilePermission, updateScribeFile } from '../../../slices/scribeFileSlice';
import { fetchSharingPermissionsForDocument } from './actions';

export interface SharingPermissionsState {
  permissions: { [key: string]: SharingPermissions };
  loading: boolean;
}

const initialState: SharingPermissionsState = {
  permissions: {},
  loading: false
};

const documentObtainedReducer = (state, action) => {
  const document = action.payload as { id: string; sharing_details?: SharingPermissions };

  if (document.sharing_details) {
    state.permissions[document.id] = document.sharing_details;
  }
};
// For documentation about sharing permissions, see the README of the monorepo

export const sharingPermissionsSlice = createSlice({
  name: 'sharingPermissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSharingPermissionsForDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSharingPermissionsForDocument.fulfilled, (state, action) => {
        const { documentId } = action.meta.arg;
        const permObject = action.payload;

        state.permissions[documentId] = permObject;
        state.loading = false;
      })
      .addCase(fetchSharingPermissionsForDocument.rejected, (state) => {
        state.loading = false;
      })
      .addCase(setScribeDocument, documentObtainedReducer)
      .addCase(setScribeFileData, documentObtainedReducer)
      .addCase(getScribeFile.fulfilled, documentObtainedReducer)
      .addCase(updateScribeFile.fulfilled, documentObtainedReducer)
      .addCase(updateFilePermission.fulfilled, documentObtainedReducer)
      .addCase(setCurrentKnowledgePage, documentObtainedReducer)
      .addCase(updateKnowledgePage.fulfilled, documentObtainedReducer)
      .addCase(signOut, () => initialState);
  }
});

export default sharingPermissionsSlice.reducer;
